"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const surface_1 = require("../../../../../../surface");
const withInlineValidation_1 = __importDefault(require("../../../../../wrappers/withInlineValidation"));
const links_1 = require("../../../../../utils/links");
class TextArea extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.handleChange = event => this.props.onChange(event.target.value);
    }
    render() {
        const { id, value, placeholder, required, disabled, invalid, formContext } = this.props;
        // check if the widget is locked because of forms links
        const isLocked = links_1.isLockedWidget(id, formContext.links);
        const textAreaProps = {
            value,
            id: id,
            placeholder,
            disabled: disabled || isLocked,
            handleChange: this.handleChange,
            required,
            status: invalid ? 'invalid' : null
        };
        return jsx_runtime_1.jsx(surface_1.Textarea, Object.assign({}, textAreaProps, { hideErrorMessage: true }), void 0);
    }
}
exports.TextArea = TextArea;
TextArea.defaultProps = {
    id: '',
    label: '',
    value: '',
    placeholder: null,
    required: false,
    disabled: false,
    onChange: () => { }
};
exports.default = withInlineValidation_1.default(TextArea);
//# sourceMappingURL=index.js.map